import React from 'react';
import { Container, Typography, Box, Breadcrumbs, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import InvoiceUploadForm from '../../components/invoices/InvoiceUploadForm';

const InvoiceUpload: React.FC = () => {
  return (
    <Container>
      <Box sx={{ mt: 3, mb: 4 }}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link component={RouterLink} to="/dashboard" color="inherit">
            Panel de Control
          </Link>
          <Link component={RouterLink} to="/invoices" color="inherit">
            My Invoices
          </Link>
          <Typography color="textPrimary">Upload Invoice</Typography>
        </Breadcrumbs>
      </Box>
      
      <InvoiceUploadForm />
    </Container>
  );
};

export default InvoiceUpload;
